import { makeStyles } from '@material-ui/core';

import { filterBaseStyles } from '../Filters/Filters.styled';

export const useStyles = makeStyles(
  theme => ({
    ...filterBaseStyles(theme),
    typeSelect: {
      flex: 1
    },
    rangeContainer: {
      display: 'flex',
      gap: theme.spacing(1),
      marginTop: theme.spacing(1)
    }
  }),
  { name: 'SalaryFilter' }
);
